'use client';
import IconLogout from '@/assets/icons/profile-popup/icon-logout.svg';
import comparisonStore from '@/zustand/comparison';

import DefaultImage from '@/assets/icons/default-avatar-icon-of-social-media-user-vector.jpg';
import { useUserFavoritesQuery } from '@/graphql';
import { Link, useRouter } from '@/i18n/navigation';
import { favoritesStore } from '@/zustand/favourite';
import useUserStore from '@/zustand/useUser';
import viewedVariantStore from '@/zustand/viewedVariant';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { FaRegUser } from 'react-icons/fa';
import { Button } from 'rsuite';
import { profileListsData } from './data';
import styles from './profile.module.scss';

interface ProfilePopupContentProps {
  setOpenCabinet: (open: boolean) => void;
  handleClose?: () => void;
  handleOpenMobileMenu?: () => void;
}

const ProfilePopupContent = ({
  setOpenCabinet,
  handleClose,
  handleOpenMobileMenu,
}: ProfilePopupContentProps) => {
  const { user, clearUser } = useUserStore();
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  const favorites = favoritesStore(e => e.favorites);
  const setFavorites = favoritesStore(e => e.setFavorites);
  const comparison = comparisonStore(e => e.comparison);
  const setComparison = comparisonStore(e => e.setComparison);
  const viewedVariant = viewedVariantStore(e => e.viewedVariant);
  const setViewedVariant = viewedVariantStore(e => e.setViewedVariant);
  const router = useRouter();
  const cabinetRef = useRef<HTMLDivElement>(null);
  const profileLists = profileListsData();
  const handleClick = () => {
    setOpenCabinet(true);
  };

  const handleLogout = () => {
    clearUser();
    setFavorites([]);
    setComparison([]);
    setViewedVariant([]);
    router.push('/');
  };
  const {
    data: favoriteData,
    loading,
    refetch: refetchFavoriteData,
  } = useUserFavoritesQuery({
    variables: { first: 10 },
    context: {
      requiresAuth: true,
    },
  });
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cabinetRef.current &&
        !cabinetRef.current.contains(event.target as Node)
      ) {
        handleClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  return (
    <div className={styles.profilePopupWrapper} ref={cabinetRef}>
      <div className={styles.contentWrapper}>
        {user ? (
          <div className={styles.profile}>
            <div className={styles.leftSideUserInfo}>
              <div className={styles.profilePlaceholderIcon}>
                {user?.avatar?.url ? (
                  <Image
                    src={
                      user?.avatar === null ? DefaultImage : user?.avatar.url
                    }
                    alt="User Avatar"
                    width={48}
                    height={48}
                    className={styles.leftUserAvatar}
                  />
                ) : (
                  <FaRegUser className={styles.leftUserIcon} />
                )}
              </div>
              <div className={styles.profileInfo}>
                <p className={styles.profileName}>
                  {`${firstName} ${lastName}`.trim() !== ''
                    ? `${firstName} ${lastName}`
                    : ''}
                </p>
                <p className={styles.profileNumber}>{user?.phone}</p>
              </div>
            </div>
            <div className={styles.profileIcon} onClick={handleLogout}>
              <IconLogout />
            </div>
          </div>
        ) : (
          <Button
            type="button"
            onClick={handleClick}
            className={styles.registerBtn}
          >
            Вход или регистрация
          </Button>
        )}
        <ul>
          {profileLists.map(item => (
            <li key={item.slug} onClick={handleOpenMobileMenu}>
              <Link href={`/pages/${item.slug}`} className={styles.link}>
                {item.icon} <span>{item.title}</span>
                {/* {item.id === 2 && (
                  <span className={styles.bonus}>Авторизуйтесь</span>
                )} */}
                {item.slug === 'history' &&
                  (viewedVariant?.length !== 0 ? (
                    <span className={styles.count}>
                      {viewedVariant?.length}
                    </span>
                  ) : null)}
                {item.slug === 'comparison' &&
                  (comparison?.length !== 0 ? (
                    <span className={styles.count}>{comparison?.length}</span>
                  ) : null)}
                {item.slug === 'favorites' &&
                  (favoriteData?.me?.favorites?.edges?.length !== 0 ? (
                    <span className={styles.count}>
                      {favoriteData?.me?.favorites?.edges?.length}
                    </span>
                  ) : null)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProfilePopupContent;
